import React from 'react';

/**
 * EmptyState — Accrezeo brand empty state pattern
 *
 * Pattern:
 *   Icon (Phosphor, weight="light", w-12 h-12, text-slate-300)
 *   Heading (what this page is for)
 *   Subtext (actionable next step for the CEO)
 *   Optional Button (primary action)
 */
export function EmptyState({ title, description, icon: Icon, action }) {
    return (
        <div className="flex flex-col items-center justify-center py-16 text-center">
            {Icon && (
                <Icon weight="light" className="w-12 h-12 text-slate-300 mb-4" />
            )}
            <h3 className="text-lg font-semibold text-slate-700 mb-1">
                {title}
            </h3>
            <p className="text-sm text-slate-500 max-w-md mb-6">
                {description}
            </p>
            {action && action}
        </div>
    );
}
